import React from 'react';
import { ui } from '../ui';

/** A calm empty state: what is (not) here and what to do next. */
export const EmptyState: React.FC<{ title: string; hint?: React.ReactNode; action?: React.ReactNode }> = ({ title, hint, action }) => (
  <div role="status" style={{ ...ui.card, alignItems: 'center', textAlign: 'center', padding: 24, gap: 6 }}>
    <div style={{ fontWeight: 700 }}>{title}</div>
    {hint && <div style={ui.muted}>{hint}</div>}
    {action && <div style={{ marginTop: 6 }}>{action}</div>}
  </div>
);
